import React from 'react'
import KpiCardsSection from '../components/KpiCardsSection'
import DetailsTable from '../detail_components/DetailsTable'

export function createReportDetailsTab({
  displayName,
  headers,
  renderRow,
  supportsSettlement = false
}) {
  function ReportDetailsTab({
    activeTab,
    selectedTab,
    kpiData,
    data,
    currentPage,
    totalPages,
    handlePaginationClick,
    onSearchQuery,
    searchQuery,
    onRowClick,
    filterContent = null,
    isSingleDayRange = true,
    shouldShowReset = false,
    onResetFilters = null
  }) {
    return (
      <div>
        <KpiCardsSection
          kpiData={kpiData}
          selectedTab={selectedTab}
          {...(supportsSettlement ? { isSingleDayRange } : {})}
        />
        <DetailsTable
          data={data}
          currentPage={currentPage}
          totalPages={totalPages}
          handlePaginationClick={handlePaginationClick}
          onSearchQuery={onSearchQuery}
          searchQuery={searchQuery}
          onRowClick={onRowClick}
          headers={headers}
          renderRow={
            supportsSettlement ? (model) => renderRow(model, { isSingleDayRange }) : renderRow
          }
          effectivenessTabKey={activeTab}
          {...(supportsSettlement
            ? {
                filterContent,
                shouldShowReset,
                onResetFilters
              }
            : {})}
        />
      </div>
    )
  }

  ReportDetailsTab.displayName = displayName
  return ReportDetailsTab
}
